/*************************************************/
/* ACCORDIONS                                    */
/*************************************************/

export function accordions() {
    let $accordionHeader,
        accordionActiveClass,
        resizeTimer;

    const init = function () {

        $accordionHeader = document.getElementsByClassName("accordion-item__header"),
            accordionActiveClass = "accordion-item--active";

        for (var i = 0; i < $accordionHeader.length; i++) {
            $accordionHeader[i].addEventListener("click", function () {
                this.parentNode.classList.toggle(accordionActiveClass);
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }

        // Reset maxHeight's on active items if screen width changes
        $(window).on("resize", function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                for (var ii = 0; ii < $accordionHeader.length; ii++) {
                    if ($accordionHeader[ii].parentNode.classList.contains(accordionActiveClass)) {
                        var activePanel = $accordionHeader[ii].nextElementSibling;
                        activePanel.style.maxHeight = activePanel.scrollHeight + "px";
                    }
                }
            }, 250);
        });

    };

    init();
}

